import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/explorer/internal-write-path-readiness/page.tsx");
